import React from 'react';
import ReactDOM from 'react-dom';
import domready from 'domready';
import Banner from './components/Banner';
domready(() => {
  const $containerEl = document.getElementById('react-cms-banner');
  const category = <Banner />;
  if ($containerEl) ReactDOM.render(category, $containerEl);
});
